import {useEffect, useRef, useState} from 'react';
import {Container,Content,Header,Body,AvatarArea,Description,Line,Actions,Input,Button,Load} from './styled';
import {Avatar} from '../../components';
import {IoIosClose} from 'react-icons/io';
import {useChat} from '../../contexts/chat';
import {PhoneCompany} from '../../contexts/auth';
import { maskPhone } from '../../utils';
import {getAccessibilityByPhone,postAccessibilityByPhone} from '../../service/serviceChat/chatService';

export function ProfileClient(props){
   
    const {client,name,isOpen,close,load} = props;

    const {UpdateNameClient,functionality} = useChat();

    const refSwitch = useRef();
    const avatar = name || client.client_name;
    const phone = client.client_phone;
    const [clientName,setClientName] = useState(name || client.client_name);
    const [loading,setLoading] = useState(false);
    
    useEffect(()=>{
        async function loadingAccessibility(){
            const accessibility = await getAccessibilityByPhone(phone);
            if(accessibility.length < 1) return
            refSwitch.current.checked = true;
        }
        loadingAccessibility()
    },[])


    async function handSaveEditName(){
        setLoading(true)
        if(clientName === '') setClientName(client.client_name)
        const success = await UpdateNameClient(clientName,phone,PhoneCompany())
        if(!success) return
        load()
        close()
    }

    async function handSaveAccessibility(){
        return await postAccessibilityByPhone(phone,1)
    }


    return(
        <Container isOpen={isOpen}> 
            <Content>
                <Header>
                    <span className='icon'>
                        <IoIosClose onClick={()=>close()}/>
                    </span>
                </Header>  
                <Body>
                    <AvatarArea>
                        <Avatar name={avatar} width={'100%'} height={'100%'} fontSize={'2.5rem'}/>
                    </AvatarArea>
                    <Description>
                        <span>
                            {maskPhone(phone)}
                        </span>
                    </Description>
                    <Line>
                        <label>Nome</label>
                        <Input value={clientName} onChange={(e)=>setClientName(e.target.value)} loading={loading}/>
                    </Line>  
                    {functionality.includes('somente_audio') &&
                        <Line>
                            <div className='accessibility'>
                                <span>Enviar somente audio</span>
                                <label className='switch'>
                                    <input type='checkbox' ref={refSwitch} onClick={()=>handSaveAccessibility()}/>
                                    <span className='slider round'/>
                                </label>
                            </div>
                        </Line>
                    }
                    <Actions>
                       <Button onClick={()=>handSaveEditName()} loading={loading}>
                            {!loading 
                                ?<>Salvar</>
                                :<Load/>
                            }
                       </Button>
                    </Actions>
                </Body>             
            </Content>         
        </Container>
    );
}